import type { ReactNode } from 'react'
import { Helmet } from 'react-helmet-async'
import { BrandSprite } from '@/components/brand/BrandSprite'
import { BackToTop } from '@/components/layout/BackToTop'
import { SiteFooter } from '@/components/layout/SiteFooter'
import { SiteNav } from '@/components/layout/SiteNav'
import { MotionProvider } from '@/components/motion/MotionProvider'
import { useMotion } from '@/components/motion/motion'
import { cx } from '@/lib/cx'

type SiteShellProps = {
  children: ReactNode
  /** Old pages kept until they are modernised (src/legacy) render full bleed, as they were designed. */
  legacy?: boolean
}

const ShellFrame = ({ children, legacy }: SiteShellProps) => {
  const { paused } = useMotion()

  return (
    <div className={cx('site', paused && 'motion-paused')}>
      <Helmet>
        <link rel="preload" href="/fonts/feature-deck/feature-deck-regular.woff2" as="font" type="font/woff2" crossOrigin="" />
      </Helmet>
      <BrandSprite />
      <SiteNav />
      <main id="main" className={legacy ? 'legacy-page' : undefined}>
        {children}
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  )
}

/** The frame of every site page: nav, footer, back to top, brand symbols and the shared pause state. */
export const SiteShell = ({ children, legacy = false }: SiteShellProps) => (
  <MotionProvider>
    <ShellFrame legacy={legacy}>{children}</ShellFrame>
  </MotionProvider>
)
